import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */
export default () => {
  function init() {
    const target = '#must-haves-collection';
    new Swiper(target, {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next--must-haves',
        prevEl: '.swiper-button-prev--must-haves',
      },
      pagination: {
        el: '.swiper-pagination--must-haves',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 35,
          centeredSlides: false,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        440: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: false,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
